/* global Swiper */

/**
 * @typedef {{ destroy: (deleteInstance?: boolean, cleanStyles?: boolean) => void }} SwiperInstance
 */

/**
 * @typedef {Element & { swiper?: SwiperInstance }} SwiperElement
 */

/** @type {new (element: Element, options: object) => SwiperInstance} */
const SwiperConstructor = /** @type {any} */ (globalThis).Swiper;

function isReducedMotionPreferred() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * @param {Element} root
 */
function updateVideoMotionPreferences(root) {
  if (!isReducedMotionPreferred()) {
    return;
  }

  root.querySelectorAll('video.swoc__media[autoplay]').forEach((videoEl) => {
    /** @type {HTMLVideoElement} */
    const videoNode = /** @type {HTMLVideoElement} */ (videoEl);
    videoNode.removeAttribute('autoplay');
    videoNode.removeAttribute('loop');
    videoNode.pause();
  });
}

function initSeeWhatOthersCreated() {
  document.querySelectorAll('[data-swoc]').forEach((sectionEl) => {
    updateVideoMotionPreferences(sectionEl);
  });

  document.querySelectorAll('[data-swoc-swiper]').forEach((el) => {
    const swiperEl = /** @type {SwiperElement} */ (el);

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new SwiperConstructor(swiperEl, {
      loop: !isReducedMotionPreferred(),
      grabCursor: true,
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: 'auto',
          spaceBetween: 16,
          centeredSlides: false,
        },
        990: {
          enabled: false,
        }
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSeeWhatOthersCreated);
} else {
  initSeeWhatOthersCreated();
}

document.addEventListener('shopify:section:load', (e) => {
  const sectionRoot = /** @type {Element|null} */ (e.target instanceof Element ? e.target : null);

  if (sectionRoot && sectionRoot.querySelector('[data-swoc]')) {
    initSeeWhatOthersCreated();
  }
});

document.addEventListener('shopify:section:unload', (e) => {
  if (!(e.target instanceof Element)) {
    return;
  }

  e.target.querySelectorAll('[data-swoc-swiper]').forEach((el) => {
    const swiperEl = /** @type {SwiperElement} */ (el);

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  });
});
